"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function BookTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'book',
        theme: 'twotone',
        nameWithTheme: 'book-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3 5.1 7.2 15.1 8.9 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M668 345.9V136h-96v211.4l49.5-35.4z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9c-7.2 5.2-17.2 3.5-22.3-3.7-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z'
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'book-twotone';
var BookTwoTone = temp;
exports.default = BookTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/twotone/BookTwoTone.js
// module id = 858
// module chunks = 0 1